import React, { useEffect, useState } from "react";


interface Props {
    children: React.ReactNode;
    isHome?: boolean;
}

const PageContainer: React.FC<Props> = ({ children, isHome = false }) => {
    return (
        <div className={`${isHome ? "page-content-home" : ""}`}>
            {children}
        </div>
    );
};

export default PageContainer;
